import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd, Route, NavigationStart } from '@angular/router';
import { AppModel } from './app.model';
import { ConfigurationService } from './shared/configuration/configuration.service';
import { InMemoryStorageService } from './shared/storage/in-memory-storage.service';



@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {

  printSequence: number = 1;
  showAdminNavigation: boolean;
  dropdownOpen: boolean;
  showLoader: boolean;
  isSessionOff: boolean = true;
  showFooter: boolean = false;
  isAdminLoggedIn: boolean;
  isSubscriberLoggedIn: boolean;
  isSMELoggedIn: boolean;
  appModel: AppModel;
  isCustomReportPage: boolean;
  activateSME: boolean = false;
  activateAdmin: boolean = false;
  showSmeMenu: boolean;
  showAdminMenu: boolean;

  constructor(private _router: Router, private configurationService: ConfigurationService, private inMemoryStorage: InMemoryStorageService) {
    this.showAdminNavigation = false;
    this.dropdownOpen = false;
    this.appModel = new AppModel(configurationService);
    //add NavigationStart;
    _router.events
      .filter(e => e instanceof NavigationStart)
      .subscribe((e: NavigationStart) => {
        this.navigationStart(e);
      });
    _router.events
      .filter(e => e instanceof NavigationEnd)
      .subscribe((e: NavigationEnd) => {
        this.navigationEnd(e);
        window.scrollTo(0, 0);
      });
  }


  handleUserInactivity() {
    this._router.navigate(['logout']);
  }


  ngOnInit() {
    this.isAdminLoggedIn = this.appModel.isAdminLoggedIn();
    this.isSubscriberLoggedIn = this.appModel.isSubscriberLoggedIn();
    this.isSMELoggedIn = this.appModel.isSMELoggedIn();
    //check on refresh
    if (this._router.url.length > 2) {
      this.isSessionOff = this.getSessionOff;
      this.showFooter = !this.footerCondition;
    }
    else {
      this.isSessionOff = true;
      this.showFooter = false;
    }

  }

  navigationStart(e) {
    var _url = e.url;

    this.isCustomReportPage = false;

    if (_url.indexOf('/reports/custom') > -1) {
      this.isCustomReportPage = true;
    }
    else if (_url.indexOf("reports/overall-losses") > -1 || _url.indexOf("reports/oee-losses") > -1) {

      let reportName = this.inMemoryStorage.getItem("selectedReportNameToIgnoreIdleTimeout");
      if (reportName != null && reportName != "" && reportName != undefined && reportName.indexOf("Full List") > -1) {
        this.isCustomReportPage = true;
      }
    }

    if (_url.indexOf("eldm") > -1 || _url.indexOf('update-index-file') > -1 ||
      _url.indexOf('announcements') > -1 || _url.indexOf('terms-of-use') > -1
      || _url.indexOf('reference-document') > -1 ||
      _url.indexOf('validate-loss-data-submission/validation-list') > -1
    ) {
      this.activateSME = true
    }
    else {
      this.activateSME = false;
    }


    if (_url.indexOf("subscription-dashboard") > -1 || _url.indexOf('accounts') > -1 ||
      _url.indexOf('activity-log') > -1) {
      this.activateAdmin = true
    }
    else {
      this.activateAdmin = false;
    }
  }

  navigationEnd(e) {
    var _url = e.url;
    if (_url.length > 2) {
      this.isSessionOff = this.getSessionOff;
      this.showFooter = !this.footerCondition;
    }
    else {
      this.isSessionOff = true;
      this.showFooter = false;
    }
  }


  get getSessionOff() {
    return (this._router.url.includes('logout') || this._router.url.includes('forbidden')
      || this._router.url.includes('login-callback') || this._router.url.includes('id_token'));
  }

  get footerCondition() {
    return (this._router.url.includes('login-callback') || this._router.url.includes('id_token'));
  }


  changeNavigation() {
    this.showAdminNavigation = true;
  }

  logout() {
    this._router.navigate(['logout']);
  }

  menuMobileToggle() {
    $('.navbar-toggler').toggleClass("opentime closedtime");
    $('.nav-mobile-text').toggleClass("hidden-sm-down hidden-sm-up");
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts